var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSupportUser
    ? _c("div", { staticClass: "tile is-parent pl-1" }, [
        _c("section", { staticClass: "tile is-child box" }, [
          _c("div", [
            _c("span", { staticClass: "subtitle" }, [
              _vm._v("Available New Menus"),
            ]),
            _c(
              "ul",
              { staticClass: "list-style-reset" },
              _vm._l(_vm.menus, function (menu) {
                return _c("li", { key: menu.menuCode }, [
                  _c("span", [_vm._v(_vm._s(menu.menuName))]),
                ])
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "pt-5" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: {
                  click: function ($event) {
                    return _vm.grantNewMenusAccess()
                  },
                },
              },
              [_vm._v("Grant Access")]
            ),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
        _c(
          "div",
          {
            staticClass:
              "notification is-danger is-flex is-justify-content-center is-size-4",
            staticStyle: { width: "50%" },
          },
          [_vm._v(" You do not have permissions on this page ")]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }